<template>
  <div id="mb-games-grid-electron">
    <!-- <mb-games v-if="gamesState"></mb-games> -->
    <transition name="grid-game-fade">
      <mb-film
        style="z-index: 16"
        v-if="modalFilm"
        :film-title="film.title"
        :film-src="film.src"
        :film-bcg="items.bcg || null"
      >
      </mb-film>
    </transition>
    <img class="games-grid-bcg" v-if="items" :src="items.bcg" />
    <div class="games-grid-box" v-if="items">
      <div
        class="games-grid-box-item"
        :key="'multibook-type' + index"
        v-for="(it, index) in items.items"
        :class="{ 'games-grid-disable-item': it.disable }"
        :style="[{ width: (100 - 10) / items.items.length + '%' }, it.cssStyle]"
      >
        <img class="games-grid-img" :src="it.bcg" :style="setScale(index)" />
        <!-- <div class="games-grid-clip-path"></div> -->
        <div
          class="games-grid-mask"
          :style="[setScale(index), { 'clip-path': 'polygon(' + it.mask + ')' }]"
          @click="redirectTo(it.type, it.redirect, colors[index])"
          @mouseenter="hoverOnSet(index)"
          @mouseout="hoverOnSet(-1)"
          @mouseleave="hoverOnSet(-1)"
        ></div>
      </div>
      <transition name="grid-game-fade">
        <div v-if="modalStatus" class="games-grid-modal">
          <img class="games-grid-bcg" v-if="items.bcg" :src="items.bcg" />
          <div
            :key="'game-grid-items-inside-' + indexIns"
            class="game-grid-modal-items"
            v-for="(itIns, indexIns) in itemsInside"
            :style="{ background: actualColor }"
            @click="redirectTo('game', itIns.id, actualColor)"
          >
            <p class="small-txt">{{ itIns.text }}</p>
            <p class="large-txt">{{ indexIns + itIns.index }}</p>
          </div>
        </div>
      </transition>
    </div>

    <svg @click="redirectMain" class="home-btn" viewBox="0 0 24 24" fill="white" style="width: 2.5vw; width: 2.5vw">
      <path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z" />
      <path class="center" d="M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z" opacity=".3" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
    <transition name="grid-game-fade">
      <svg
        v-if="modalStatus || modalFilm"
        @click="
          modalStatus = false;
          modalFilm = false;
        "
        class="close-btn"
        viewBox="0 0 24 24"
        fill="white"
        style="width: 2.5vw; width: 2.5vw"
      >
        <path
          d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
        />
        <path
          class="center"
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          opacity=".3"
        />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </transition>
    <!-- <dir @click="redirectMain" class="home-btn" v-if="isWeb || multiconfig">
      <img :src="homeIcon" alt="Home" />
    </dir> -->
    <img class="logo-box" src="./logoMAC_kolor.png" alt="Logo MAC S.A." />
  </div>
</template>
<script>
// import INFO from '../../config/info/tablice.js';
import _ from 'lodash';
import MbFilm from './MbFilm/MbFilm';
export default {
  name: 'mb-games-grid-electron',
  components: {
    MbFilm,
  },
  data: function () {
    return {
      gamesKeys: null,
      info: null,
      items: null,
      hoverOn: -1,
      modalStatus: false,
      modalFilm: false,
      film: {
        title: '',
        src: '',
      },
      actualColor: '#ffffff',
      itemsInside: [],
      colors: [
        '#009548',
        '#0074b8',
        '#971e7d',
        '#f88f31',
        '#009aa0',
        '#db007c',
        '#92bf3d',
        '#eb2f27',
        '#fabed4',
        '#dcbeff',
        '#9A6324',
        '#aaffc3',
      ],
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next();
  // },
  mounted() {
    this.init();
  },
  methods: {
    redirectTo(type, route, color) {
      // console.log([type, route, color]);
      if (type == 'game' && route) {
        if (typeof route == 'string') this.$router.push('/game/' + route);
        else {
          this.modalStatus = true;
          this.actualColor = color;
          this.itemsInside = route;
        }
      } else if (type == 'film' && route) {
        this.film.title = route.title;
        this.film.src = route.src;
        this.modalFilm = true;
      } else {
        this.redirectMain();
      }
    },
    hoverOnSet(index) {
      this.hoverOn = index;
    },
    setScale(index) {
      if (index == this.hoverOn) {
        return { transform: 'scale(1)' };
      } else {
        return {};
      }
    },
    redirectMain() {
      this.$router.push(`/`);
    },
    init() {
      this.items = this.$router.currentRoute.params.items;
      if (!this.items) {
        this.redirectMain();
      }
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch {
        console.log(
          '%cImgagePath MbGamesGridElectron- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
    },
  },
  computed: {
    isWeb() {
      return this.$store.getters.isWeb;
    },
    multiconfig() {
      return this.$store.getters.multiconfigTest;
    },
    homeIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/book/headerBar/home-48px.svg`);
      } catch {
        console.log(
          '%cHomeIcon MbGamesGridElectron- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>

<style lang="sass">
$break-large: 1400px
#mb-games-grid-electron
  width: 100vw
  height: 100vh
  background: #0054a3
  overflow: hidden
  color: white
  .games-grid-box
    width: 100%
    height: 100%
    display: flex
    flex-direction: row
    position: absolute
    top: 0
    left: 0
    align-items: center
    justify-content: center
    .games-grid-modal
      display: flex
      justify-content: center
      align-items: center
      flex-wrap: wrap
      position: fixed
      width: 100%
      height: 100%
      top: 0
      left: 0
      background: rgba(255,255,255, .6)
      z-index: 15
      text-align: center
      .games-grid-bcg
        position: absolute
        width: 100vw
        height: 100vh
        top: 0
        left: 0
      .game-grid-modal-items
        border-radius: 50%
        display: flex
        flex-wrap: wrap
        justify-content: center
        align-items: center
        width: 16vw
        font-family: "Mr Dodo Medium"
        height: 16vw
        margin: 2vw
        position: relative
        z-index: 15
        transform: scale(.8)
        transition: .5s
        .small-txt
          position: absolute
          top: 2.5vw
          font-size: 3vw
        .large-txt
          position: absolute
          top: 4.5vw
          font-family: "Mr Dodo Medium"
          font-size: 8vw
          width: 100%
          margin: 0
        &:hover
          transform: scale(1)

    .games-grid-box-item
      // $root: &
      // max-width: 80%
      // max-height: 80%

      .games-grid-mask
        background: transparent
        position: absolute
        top: 0
        width: 100%
        height: 100%
        cursor: pointer
        transform: scale(.8)
        transition: .5s
        z-index: 15
      .games-grid-clip-path
        width: 100%
        height: 100%
        top: 0
        position: absolute
        background: transparent
        clip-path: polygon(0% 0%, 0% 100%, 31% 100%, 34% 27%, 71% 30%, 71% 71%, 31% 73%, 27% 100%, 100% 100%, 100% 0%)
      .games-grid-img
        width: 100%
        height: 100%
        transform: scale(.8)
        transition: .5s

    .games-grid-disable-item
      filter: grayscale(1) !important
      img
        transform: scale(.8) !important
        cursor: auto
        &:hover
          transform: scale(.8) !important
  .games-grid-bcg
    position: absolute
    width: 100vw
    height: 100vh
    top: 0
    left: 0
  h1
    color: white
  .games-items
    width: 100%
    height: calc(100%)
    text-align: center
    padding-top: 2vmin

    .games-items-scroll
      overflow-y: scroll
      max-height: calc(100% - 3rem - 2vmin)
      .games-items-not-full
        width: 80%
        margin-left: 10%
        .games-item
          // box-shadow: .5vh .5vh 2vh 0vh rgba(0,0,0,.5)
          background: white
          width: calc(30vmax * 0.5625)
          max-width: 30vmax
          height: calc(30vmax * 0.5625)
          display: inline-block
          text-align: center
          margin: 3vmin
          position: relative
          transition: .5s
          cursor: pointer
          overflow: hidden
          // @media screen and (max-width: $break-large)
          //   width: 30vmax
          //   height: calc(30vmax * 0.5625)
          &:hover
            transform: scale(1.1)
          .tooltip
            left: 5%
            top: 5%
            width: 90% !important
            height: 90% !important
            display: flex
            align-items: center
            opacity: 1
            justify-content: center
            font-size: 1.2rem
            p
              color: #0054a3
              margin: 0
              opacity: 1
              padding: 0
              text-align: center
              font-size: 1.8rem !important
              @media screen and (max-width: $break-large)
                font-size: 1.6rem !important
          img
            max-width: 100%
            height: 100%
          .games-title
            max-height: 50%
            width: 100%
            position: absolute
            bottom: 0
            background: rgba(0,0,0,.5)
            margin: 0
            padding: 0
            // opacity: 0
            transition: .5s
            p
              margin: 0
              padding: 0
.logo-box
  height: 10vw
  position: absolute
  bottom: 1vh
  right: 1vh
  opacity: 0
  display: flex
  justify-content: center

.games-items-scroll::-webkit-scrollbar-track
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)
	background-color: #0054a3

.games-items-scroll::-webkit-scrollbar
	width: 10px
	background-color: #0054a3

.games-items-scroll::-webkit-scrollbar-thumb
	background-color: #309de4
	border: 2px solid #309de4

.grid-game-fade-leave-active, .grid-game-fade-enter-active
  transition: all .5s .0s linear

.grid-game-fade-leave-to, .grid-game-fade-enter
  opacity: 0

.grid-game-item-inside-fade-leave-active, .grid-game-fade-enter-active
  transition: all .5s .5s linear

.grid-game-item-inside-fade-leave-to, .grid-game-fade-enter
  opacity: 0

.home-btn, .close-btn
  position: absolute
  top: 0
  margin: 1rem !important
  padding-left: 0 !important
  padding-right: 0 !important
  transition: all 0.4s ease
  transform: scale(1) !important
  cursor: pointer
  z-index: 16
  .center
    fill: transparent
  img:hover
      cursor: pointer
      background: url('~@/assets/icons/book/headerBar/home-on48px.svg')
  &:hover
    transform: scale(1) !important
    .center
      fill: gray
.close-btn
  right: 0
.home-btn
  left: 0
.disable-games
  filter: grayscale(1)
  background: gray !important
  &:hover
    transform: scale(1) !important
</style>
